module.exports = __webpack_public_path__ + "img/test.3a0fa91f.png";